import React from 'react';
import { Fab, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { func } from 'prop-types';

const styles = makeStyles(({ spacing, palette }: any) => ({
  root: {
    top: spacing(5),
    right: spacing(5),
    position: 'fixed',
    background: palette.background.default,
    zIndex: 1301,
    '& svg': {
      fill: palette.background.dark,
    },
  },
}));

const CloseButton = React.forwardRef(({ onClick, ...props }: any, ref) => {
  const classes = styles();
  return (
    <Fab
      className={classes.root}
      size="medium"
      onClick={onClick}
      data-testid="closedialog"
      aria-label="close"
      ref={ref}
      {...props}
    >
      <CloseIcon />
    </Fab>
  );
});

CloseButton.propTypes = {
  onClick: func.isRequired,
};

export default CloseButton;
